export default __webpack_public_path__ + "static/media/mascote-corpo.62cc91de.webp";